// noinspection JSUnusedGlobalSymbols

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import type * as Types from '../../__generated__/types';
import type { ManagerFragment } from './getManager.generated';
import { ManagerFragmentDoc } from './getManager.generated';

const defaultOptions = {} as const;
export type GetPendingManagerChangeReservationQueryVariables = Types.Exact<{
  employeeId: Types.Scalars['ID']['input'];
}>;

export type GetPendingManagerChangeReservationQuery = { __typename?: 'Query' } & {
  pendingManagerChangeReservation: Types.Maybe<
    { __typename?: 'ManagerChangeReservation' } & Pick<
      Types.ManagerChangeReservation,
      'id' | 'effectiveDate' | 'primaryManagerId' | 'dottedLineManagerId'
    > & {
        primaryManager: Types.Maybe<{ __typename?: 'Employee' } & ManagerFragment>;
        dottedLineManager: Types.Maybe<{ __typename?: 'Employee' } & ManagerFragment>;
      }
  >;
};

export const GetPendingManagerChangeReservationDocument = /*#__PURE__*/ gql`
    query GetPendingManagerChangeReservation($employeeId: ID!) {
  pendingManagerChangeReservation(employeeId: $employeeId) {
    id
    effectiveDate
    primaryManagerId
    primaryManager {
      ...Manager
    }
    dottedLineManagerId
    dottedLineManager {
      ...Manager
    }
  }
}
    ${ManagerFragmentDoc}`;

/**
 * __useGetPendingManagerChangeReservationQuery__
 *
 * To run a query within a React component, call `useGetPendingManagerChangeReservationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPendingManagerChangeReservationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPendingManagerChangeReservationQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useGetPendingManagerChangeReservationQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPendingManagerChangeReservationQuery,
    GetPendingManagerChangeReservationQueryVariables
  > &
    ({ variables: GetPendingManagerChangeReservationQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPendingManagerChangeReservationQuery, GetPendingManagerChangeReservationQueryVariables>(
    GetPendingManagerChangeReservationDocument,
    options,
  );
}
export function useGetPendingManagerChangeReservationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPendingManagerChangeReservationQuery,
    GetPendingManagerChangeReservationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPendingManagerChangeReservationQuery, GetPendingManagerChangeReservationQueryVariables>(
    GetPendingManagerChangeReservationDocument,
    options,
  );
}
// @ts-expect-error
export function useGetPendingManagerChangeReservationSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetPendingManagerChangeReservationQuery,
    GetPendingManagerChangeReservationQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  GetPendingManagerChangeReservationQuery,
  GetPendingManagerChangeReservationQueryVariables
>;
export function useGetPendingManagerChangeReservationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingManagerChangeReservationQuery,
        GetPendingManagerChangeReservationQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetPendingManagerChangeReservationQuery | undefined,
  GetPendingManagerChangeReservationQueryVariables
>;
export function useGetPendingManagerChangeReservationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetPendingManagerChangeReservationQuery,
        GetPendingManagerChangeReservationQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetPendingManagerChangeReservationQuery,
    GetPendingManagerChangeReservationQueryVariables
  >(GetPendingManagerChangeReservationDocument, options);
}
export type GetPendingManagerChangeReservationQueryHookResult = ReturnType<
  typeof useGetPendingManagerChangeReservationQuery
>;
export type GetPendingManagerChangeReservationLazyQueryHookResult = ReturnType<
  typeof useGetPendingManagerChangeReservationLazyQuery
>;
export type GetPendingManagerChangeReservationSuspenseQueryHookResult = ReturnType<
  typeof useGetPendingManagerChangeReservationSuspenseQuery
>;
